module.exports = __webpack_public_path__ + "img/mahshev_yes.004bb312.png";